import { Outlet } from 'react-router-dom'
import React from 'react'

const Product = () => {
  return (
    <Outlet/>
  )
}

export default Product